module.exports = __webpack_public_path__ + "oktaVerify_authenticator@2x.eeaca536b83962d01d2f93e7b409ba0b.png";